import Glide from '@glidejs/glide';

/**
 * Sets up leadership block with slideshow and controls
 * 
 * @returns void
 */
export function leadershipSetup() {
  
  // searches for a leadership block  to attach to, if none found returns
  var leadershipGlide = document.querySelector(".leadership-glide");

  if(!leadershipGlide){
    return;
  }

  // creates Glide instance
  let glide = new Glide(leadershipGlide, {
    type: 'slider',
    startAt: 0,
    hoverpause: true,
    // breakpoints: {
    //   500:{
    //     autoplay: false
    //   }
    // }
  });

  // start autoplay when block enters view, stop on exit
  let observer = new IntersectionObserver(function (entries, observer) {
    for (let entry of entries) {
      // console.log('the element', entry.target);
      // console.log('is intersecting', entry.isIntersecting);
      if(entry.isIntersecting){
        // console.log('start autoplay');
        glide.update({
          autoplay: 5000,
        });
      }else{
        // console.log('stop autoplay');
        glide.update({autoplay: false});
      }
    }
  });

  observer.observe(leadershipGlide);

  // glide.on('update', function(){
  //   console.log('update', glide.settings);
  // });
  

  // starts the instance
  glide.mount();
}
